import { render, staticRenderFns } from "./CidSuggestions.vue?vue&type=template&id=07d43c59"
import script from "./CidSuggestions.vue?vue&type=script&lang=js"
export * from "./CidSuggestions.vue?vue&type=script&lang=js"
import style0 from "./CidSuggestions.vue?vue&type=style&index=0&id=07d43c59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports